interface FallbackProps {
  error: unknown;
  resetError: () => void;
  componentStack?: string | null;
  eventId?: string | null;
}

export function ErrorFallback({ error, resetError }: FallbackProps) {
  const errorMessage = error instanceof Error
    ? error.message
    : "예기치 않은 오류가 발생했습니다.";

  const errorStack = error instanceof Error
    ? error.stack
    : String(error);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        <div className="mb-4">
          <svg
            className="mx-auto h-12 w-12 text-status-error"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          오류가 발생했습니다
        </h1>

        <p className="text-sm text-gray-600 mb-6">
          {errorMessage}
        </p>

        <div className="space-y-3">
          <button
            onClick={resetError}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
          >
            다시 시도
          </button>

          <button
            onClick={() => window.location.href = "/"}
            className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors font-medium"
          >
            홈으로 이동
          </button>
        </div>

        {import.meta.env.DEV && (
          <details className="mt-6 text-left">
            <summary className="cursor-pointer text-sm text-gray-500 hover:text-gray-700">
              에러 상세 정보 (개발 모드)
            </summary>
            <pre className="mt-2 text-xs bg-gray-50 p-3 rounded overflow-auto text-gray-800">
              {errorStack}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
}